/** Baked at build time from the cell catalog (see market-hubs.catalog.ts). */
export function getHubEnvironment(): typeof __HUB_ENVIRONMENT__ {
  return __HUB_ENVIRONMENT__;
}

/** Demo-only features fail closed: only a build proven to be local or staging gets them. */
export function isDemoFeatureEnvironment(environment = getHubEnvironment()): boolean {
  return environment === 'development' || environment === 'staging';
}
